import ReactNotificationTrigger from './ReactNotificationTrigger.container';
export default ReactNotificationTrigger;
